export default class StaticSearch {
  constructor(section) {}
}
